import React, { useContext, useState, useRef, useEffect } from 'react';
import { Layout } from 'antd';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import LogViewer from '../logs/LogViewer';
import useHttp from '../../hooks/useHttp';
import './MainLayout.css';
import ChatContext from '../../store/ChatContext';
import { useParams } from 'react-router-dom';
import { API_URL } from '../../services/api';

const { Content } = Layout;

const MainLayout = ({ children }) => {
  const { getRequest } = useHttp();
  const [collapsed, setCollapsed] = useState(true);
  const sidebarRef = useRef(null);
  const {chatIdentifier} = useParams();
  const chatCtx= useContext(ChatContext);
  const [showLogs, setShowLogs] = useState(false);

  const handleShowLogs = () => {
    setShowLogs(!showLogs);
  };

  const handleCollapse = (value) => {
    setCollapsed(value);
  };

  useEffect(() => {
    getRequest({
      url: API_URL + '/app/api/token',
      onResponse: (response) => {
        chatCtx.setToken(response);
      }
    });
  }, []);


  useEffect(() => {
    function handleClickOutside(event) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        const isDropdownClick = event.target.closest('.ant-dropdown-menu') || 
                               event.target.closest('.ant-dropdown') ||
                               event.target.closest('.custom-dropdown-menu');
        
        if (!isDropdownClick) {
          handleCollapse(true);
        }
      } 
    }

    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <Layout>
      <Sidebar ref={sidebarRef} collapsed={collapsed} onCollapse={handleCollapse} />
      <Layout className={`main-layout ${collapsed ? 'collapsed' : ''}`} >
        <Header collapsed={collapsed} onCollapse={handleCollapse} onShowLogs={handleShowLogs} showLogs={showLogs} />
        <Content className="main-content">
          {children}
        </Content>
      </Layout>
      {showLogs && <div className={`fixed lg:static shadow-xl transition-all duration-300 ease-in-out left-0 lg:left-2/3 top-12 right-0  ${showLogs ? 'w-full lg:w-1/3' : 'w-0'}`} >
    <LogViewer connectionId={chatIdentifier ? chatIdentifier : chatCtx.connectionId} />
    </div>}
    </Layout>
  );
};

export default MainLayout; 